import React, { FC } from 'react'
import {
  GxButton,
  GxButtonGroup,
  GxDropdown,
  GxMenu,
  GxMenuItem
} from '@garpix/garpix-web-components-react'
import cn from 'classnames'
import dayjs from 'dayjs'
import 'react-responsive-modal/styles.css'
import { useStoreon } from 'storeon/react'
import { toast } from 'react-toastify'

import { Events, State } from '@/interfaces'
import { MODALS_NAMES } from '../../../../const/modals'
import useModal from '../../../../hooks/useModal'
import {
  NAME_STATUS,
  NAME_STATUS_SCORE,
  TYPES_ACTIONS_ORDERS,
  TYPES_SCORE,
  TYPES_STATUS
} from '../../consts'
import { useOrder } from '../../helpers'
import { TYPE_MODAL_TASK } from '../ModalCreateTask/const'
import { handleClickIsPrint } from '../ScheduleHeader/helpers'
import ToastInfoContract from '../../../../components/ToastInfoContract'
import { TYPE_MODAL_ORDER } from './const'
import { TYPE_USER } from '../../../../const'

import styles from './styles/index.module.scss'

interface IModalOrderHeader {
  onRequestClose: (data?: Record<string, any>) => void
  data?: Record<string, any> | null
  date?: string | null
  formik: any
  setVisibleItem: (index: number) => void
  visibleItem: number
}

const ModalOrderHeader: FC<IModalOrderHeader> = ({
  onRequestClose,
  data,
  date,
  formik,
  setVisibleItem,
  visibleItem
}) => {
  const {
    dispatch,
    applicationInfo,
    statusTransferOrder,
    statusCreateMultiOrders,
    arrayDateTimeOrders,
    currentUser,
    ordersInfo
  } = useStoreon<State, Events>(
    'applicationInfo',
    'currentUser',
    'statusTransferOrder',
    'statusCreateMultiOrders',
    'arrayDateTimeOrders',
    'ordersInfo'
  )

  const { deleteOrder, closeOrder } = useOrder()
  const { openModal, closeModal } = useModal()

  const handleClickDate = (type: number) => {
    onRequestClose({ ...formik.values })
    if (type === TYPES_ACTIONS_ORDERS.TRANSFER) {
      dispatch('statusTransferOrder/set', true)
    } else {
      dispatch('statusCreateMultiOrders/set', true)
    }
    dispatch('applicationInfo/set', { ...formik.values })
    closeModal()
  }

  const openModalCreateTask = (): void => {
    openModal(MODALS_NAMES.modalCreateTask, {
      user: data ? data.customer : null,
      order: data || null,
      typeModal: TYPE_MODAL_TASK.ORDER
    })
  }

  const print = async () => {
    const arr: any = await handleClickIsPrint(data ? [data.id] : [])
    arr.contract_pages.forEach((item: Record<string, any>) => {
      toast(<ToastInfoContract data={item} />, {
        position: 'top-right',
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        data: item
      })
    })
  }

  return (
    <div className={styles['header']}>
      {statusTransferOrder ? (
        <h2 className={styles['header--title']}>Заявка {applicationInfo?.number}</h2>
      ) : (
        <>
          {data ? (
            <>
              {visibleItem === TYPE_MODAL_ORDER.RETURN_PAY && (
                <h2 className={styles['header--title']}>{`Возврат средств. Счет ${
                  data && typeof data.pay_order !== 'number' ? data.pay_order.id : ''
                }`}</h2>
              )}
              {visibleItem === TYPE_MODAL_ORDER.MULTI_PAY_ORDER && (
                <h2 className={styles['header--title']}>{`Счет ${data && data.pay_order.id}`}</h2>
              )}
              {(visibleItem === TYPE_MODAL_ORDER.DEFAULT ||
                visibleItem === TYPE_MODAL_ORDER.PAY_ORDER) && (
                <h2 className={styles['header--title']}>{`Заявка ${data.number}`}</h2>
              )}
            </>
          ) : (
            <h2 className={styles['header--title']}>Новая заявка</h2>
          )}
        </>
      )}
      <div className={styles['header--info']}>
        {visibleItem !== 0 ? (
          <>
            <span className={styles['header--user-name']}>
              {data && `${data.customer.last_name} ${data.customer.first_name}`}
            </span>
            <span
              className={cn(
                styles['header--info_status'],
                styles[
                  `header--info_status__${
                    visibleItem === TYPE_MODAL_ORDER.MULTI_PAY_ORDER ||
                    visibleItem === TYPE_MODAL_ORDER.RETURN_PAY
                      ? NAME_STATUS_SCORE[
                          TYPES_SCORE[
                            data && typeof data.pay_order !== 'number' ? data.pay_order.status : 0
                          ]
                        ].class
                      : NAME_STATUS[TYPES_STATUS[data ? data.status : 0]].class
                  }`
                ]
              )}
            >
              {/* eslint-disable-next-line no-nested-ternary */}
              {visibleItem === TYPE_MODAL_ORDER.MULTI_PAY_ORDER ||
              visibleItem === TYPE_MODAL_ORDER.RETURN_PAY
                ? NAME_STATUS_SCORE[
                    TYPES_SCORE[
                      data && typeof data.pay_order !== 'number' ? data.pay_order.status : 0
                    ]
                  ].title
                : data
                ? NAME_STATUS[TYPES_STATUS[data.status]].title
                : 'Новая заявка'}
            </span>
          </>
        ) : (
          <>
            <div className={styles['header--info_group']}>
              {!!data || statusTransferOrder || date ? (
                <span>
                  {`Сессия: ${
                    data
                      ? dayjs(data.start_at).format('DD/MM/YY')
                      : dayjs(date, 'YYYY.MM.DD HH:mm').format('DD/MM/YY')
                  }
                         Время: ${
                           data
                             ? dayjs(data.start_at).format('HH:mm')
                             : dayjs(date, 'YYYY.MM.DD HH:mm').format('HH:mm')
                         } `}
                </span>
              ) : (
                <>
                  {arrayDateTimeOrders && arrayDateTimeOrders.length === 0 ? (
                    <span className={styles['header--info_time']}>
                      Сессия: {dayjs(ordersInfo.date, 'YYYY.MM.DD').format('DD/MM/YYYY')} Время:
                      00:00
                    </span>
                  ) : (
                    <>
                      {arrayDateTimeOrders && arrayDateTimeOrders.length === 1 && (
                        <span className={styles['header--info_time']}>
                          {`Сессия: ${dayjs(arrayDateTimeOrders[0].date).format('DD/MM/YYYY')}
                         Время: ${arrayDateTimeOrders[0].time}`}
                        </span>
                      )}
                    </>
                  )}
                </>
              )}
              {statusTransferOrder ? (
                <span
                  className={cn(
                    styles['header--info_status'],
                    styles[
                      `header--info_status__${
                        NAME_STATUS[TYPES_STATUS[applicationInfo?.status]].class
                      }`
                    ]
                  )}
                >
                  {NAME_STATUS[TYPES_STATUS[applicationInfo?.status]].title}
                </span>
              ) : (
                <>
                  {data && (
                    <span
                      className={cn(
                        styles['header--info_status'],
                        styles[
                          `header--info_status__${
                            NAME_STATUS[TYPES_STATUS[data ? data.status : 0]].class
                          }`
                        ]
                      )}
                    >
                      {NAME_STATUS[TYPES_STATUS[data?.status]].title}
                    </span>
                  )}
                </>
              )}
            </div>
          </>
        )}
        {!statusCreateMultiOrders && !!data && visibleItem !== 2 && (
          <div className={styles['header--actions']}>
            <div>
              <p className={styles['header--info_time']}>
                {`Автор: ${formik.values.author ? formik.values.author : '-'}`}
              </p>
              <p className={styles['header--info_time']}>
                {`Дата создания: ${
                  formik.values.created_at
                    ? dayjs(formik.values.created_at).format('DD.MM.YY HH:mm')
                    : '-'
                }`}
              </p>
            </div>
            {currentUser.user_status !== TYPE_USER.VIEWER && (
              <GxButtonGroup className={styles['btn--group']}>
                <GxButton
                  className={styles['btn--modal-actions']}
                  disabled={!!data && data.status === TYPES_STATUS.CLOSE}
                  onClick={() => handleClickDate(TYPES_ACTIONS_ORDERS.TRANSFER)}
                >
                  {' '}
                  Перенос даты
                </GxButton>
                <GxDropdown hoist>
                  <GxButton slot='trigger' className={styles['btn--default']}>
                    Действия
                  </GxButton>
                  <GxMenu className={styles['menu']}>
                    {data.status !== TYPES_STATUS.CLOSE && (
                      <GxMenuItem
                        className={styles['menu__item']}
                        onClick={() => {
                          closeOrder(data.id, onRequestClose)
                        }}
                      >
                        Закрыть
                      </GxMenuItem>
                    )}
                    <GxMenuItem
                      className={styles['menu__item_blue']}
                      onClick={() => setVisibleItem(3)}
                    >
                      Возврат оплаты
                    </GxMenuItem>
                    <GxMenuItem className={styles['menu__item_blue']} onClick={print}>
                      Печать
                    </GxMenuItem>
                    <GxMenuItem
                      className={styles['menu__item_blue']}
                      onClick={() => setVisibleItem(2)}
                    >
                      Счет
                    </GxMenuItem>
                    <GxMenuItem className={styles['menu__item_blue']} onClick={openModalCreateTask}>
                      Задача
                    </GxMenuItem>
                    <GxMenuItem
                      className={styles['menu__item_red']}
                      onClick={() => deleteOrder(data.id, onRequestClose)}
                    >
                      Удалить
                    </GxMenuItem>
                  </GxMenu>
                </GxDropdown>
              </GxButtonGroup>
            )}
          </div>
        )}
      </div>
      <div className={styles['header--info']}>
        {statusCreateMultiOrders && arrayDateTimeOrders && arrayDateTimeOrders.length > 0 && (
          <span>Количество выбранных заявок: {arrayDateTimeOrders.length}</span>
        )}
      </div>
    </div>
  )
}

export default ModalOrderHeader
